module.exports = __webpack_public_path__ + "AdobeStock_285202108_panel_iconcolors2.svg?3f2418235d1ec3891e475a5a484d8af5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg
// module id = 34
// module chunks = 0